import React from "react";
import { Github, Linkedin } from "lucide-react";
import { links } from "../mock";

const Navbar = () => {
  return (
    <header className="sticky top-0 z-40 border-b-[3px] border-black bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 lg:px-10">
        <a href="#" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center border-[3px] border-black bg-[#00FF41] font-heading text-lg font-black text-black shadow-[3px_3px_0px_0px_#000000]">
            M
          </span>
          <span className="font-mono text-sm font-bold uppercase tracking-widest text-black">
            manthan.dhotre
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <a href="#work" className="font-mono text-xs font-bold uppercase tracking-widest text-black hover:underline underline-offset-4 decoration-[3px] decoration-[#00FF41]">
            Work
          </a>
          <a href="#connect" className="font-mono text-xs font-bold uppercase tracking-widest text-black hover:underline underline-offset-4 decoration-[3px] decoration-[#00FF41]">
            Connect
          </a>
        </nav>

        <a
          href={links.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border-[3px] border-black bg-white px-3 py-2 font-mono text-xs font-bold uppercase tracking-wider text-black shadow-[3px_3px_0px_0px_#000000] transition-transform duration-150 hover:-translate-x-[1px] hover:-translate-y-[1px] hover:bg-[#00FF41] hover:shadow-[5px_5px_0px_0px_#000000]"
        >
          <Linkedin className="h-4 w-4" strokeWidth={2.5} />
          <span className="hidden sm:inline">LinkedIn</span>
        </a>
      </div>
    </header>
  );
};

export default Navbar;
